<template>
  <el-dialog :visible.sync="visible" :show-close="false">
    <div class="verify">
      <div class="header">
        <div class="back" @click="closeFirst">
          <i class="el-icon-arrow-left"></i>
          <span>Back</span>
        </div>
      </div>
      <div class="verify-up">
        <!-- 根据不同状态显示不同图标 -->
        <!-- 表示申请成功 -->
        <template v-if="flag == 'completed' || flag == 'approved'">
          <img src="../../assets/success.png" alt="" />
        </template>
        <!--表示审核种  -->
        <template v-else-if="flag == 'inReview'">
          <img src="../../assets/ing.png" alt="" />
        </template>
        <!-- 审核失败，未申请 -->
        <template
          v-else-if="flag == 'declined'"
        >
          <img src="../../assets/error.png" alt="" />
        </template>

        <div class="title" v-if="flag == 'completed' || flag == 'approved'">
          Active
        </div>
        <div class="title" v-else-if="flag == 'inReview'">In Review</div>
        <div
          class="title"
          v-else-if="flag == 'declined'"
        >
          Decline
        </div>
        <!-- 通过EIN 人工授信 审核中 情况下 -->
        <div class="desc" v-if="flag === 'inReview' && bankFlag ==='false'">
          Thanks, you completed the on-boarding process with ShopVidi We will
          complete the review within 1 working day.
        </div>
        <!-- 通过银行卡授信 审核中 情况下 -->
        <div class="desc" v-if="flag === 'inReview' && bankFlag ==='true'">
          Thank you, you have completed the onboarding process through ShopVidi
We will complete the review within 1 minute.
        </div>
        <!-- 审核失败的情况下 -->
        <div class="desc" v-if="flag === 'declined' ">
          Your 60 net terms application Declined,Contact customer service.
        </div>
        <!-- 审核成功的情况下 -->
        <div class="desc" v-if="flag === 'completed'">
          Your review of 60 net terms has Active.
        </div>
      </div>
      <el-divider ></el-divider>
      <div class="verify-down">
        <div class="list">
          <div class="item">
            <div class="name" v-if="business !== ''">Business Name：</div>
            <div class="cont">{{ business }}</div>
          </div>
          <div class="item">
            <div class="name">Email：</div>
            <div class="cont">{{ this.$ls.get("userInfo").email }}</div>
          </div>
          <div class="item">
            <div class="name">Terms Qualification:</div>
            <div class="cont" v-if="flag == 'completed' || flag == 'approved'">
              Active
            </div>
            <div class="cont" v-else-if="flag == 'inReview'">In Review</div>
            <div
              class="cont"
              v-else-if="flag == 'declined'"
            >
              Decline
            </div>
          </div>
        </div>
        <!-- 增加Back Checkout 这个动态判断是否有参数传来 -->
        <div class="btn-border">
          <div class="btn" @click="openSecond" v-if="flag == 'declined'">Re-Apply</div>
          <div class="btn" @click="backHome" v-else>Back Home</div>
          <div class="btn" v-if="checkoutPath !== ''" @click="backCheckout">Back Checkout</div>
        </div>
        <div class="footer">
          You can check the application status of net terms in the menu at the top
          right corner of the page or check the status of net terms application in
          the checkout page.
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    renderLoading: {
      type: Boolean,
      default: false
    },
    step: {
      type: String,
      default: ''
    },
    flag: {
      type: String,
      default: ''
    },
    bankFlag: {
      type: String,
      default: ''
    },
    business: {
      type: String,
      default: ''
    },
    checkoutPath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false
    }
  },
  created() {
    this.visible = true
  },
  methods: {
    backCheckout() {
      window.location.href = localStorage.getItem('checkout')
      localStorage.removeItem('apply_status')
      localStorage.removeItem('checkout')
      // this.$router.push({path: 'checkout?' + this.checkoutPath})
    },
    backHome() {
      localStorage.removeItem('apply_status')
      localStorage.removeItem('checkout')
      this.$router.push({ path: '/' })
    },
    closeFirst() {
      localStorage.removeItem('apply_status')
      localStorage.removeItem('checkout')
      this.$emit('closeFirst', '')
    },
    openSecond() {
      this.$emit('openSecond', 'second')
    }
  }
}
</script>
<style lang="less" scoped>
.verify {
  position: fixed;
  width: 600px;
  background: #ffffff;
  top: 130px;
  left: 50%;
  margin-left: -300px;
  z-index: 1000;
  padding: 26px 36px;
  .header {
    font-size: 14px;
    font-weight: 600;
    color: #262b2f;
    .back {
      font-size: 18px;
      cursor: pointer;
    }
  }
  .verify-up {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #262b2f;
      margin-top: 10px;
    }
    .desc {
      font-size: 14px;
      font-family: Graphik;
      font-weight: 500;
      color: #262b2f;
      margin-top: 28px;
    }
  }

  .verify-down {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 28px;
    .list {
      display: flex;
      flex-direction: column;
      .item {
        display: flex;
        align-items: center;
        height: 30px;
        .name {
          display: flex;
          flex-direction: row-reverse;
          width: 140px;
        }
        .cont {
          display: flex;
          flex: 1;
          font-size: 14px;
          font-family: Graphik;
          font-weight: 500;
          color: #5d5d5d;
        }
      }
    }
    .btn-border{
      display: flex;
      width: 100%;
      justify-content: center;
      .btn {
        margin:0 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 35%;
        height: 50px;
        background: #ffffff;
        border: 1px solid #e1e1e1;
        opacity: 1;
        border-radius: 5px;
        margin-top: 20px;
        cursor: pointer;
      }
    }

    .reply {
      background: #262b2f;
      color: #ffffff;
    }
  }
}
.footer {
  margin-top: 50px;
  line-height: 2;
}
@media screen and (max-width: 600px) {
  .verify {
    position: fixed;
    width: calc(100vw - 90px);
    background: #ffffff;
    top: 50px;
    left: 10px;
    z-index: 1000;
    margin: 0;
    overflow-y: auto;
    .verify-up {
      margin-top: 30px;
    }
  }
  .cont{overflow: hidden; white-space: nowrap; text-overflow: ellipsis}
}
@media screen and (max-width: 380px) {
  .verify{
    top:30px;
    max-height: 450px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/credit-payment/verifyDialog.vue